// import React, { useEffect, useState, useMemo} from 'react';
// import SideviewProfile from './SideviewProfile';
// import { useGetCustomerDetailsByIdQuery, useOrderHistoryDetailsMutation } from '../services/customerApi';
// import { useGetOrderDetailsByOrderidQuery } from '../services/ordersApi';

// function OrderList() {
//   const [customer, setCustomer] = useState(null);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const customerId = JSON.parse(localStorage.getItem('customer_id'));
//   const { data, isLoading: customerLoading } = useGetCustomerDetailsByIdQuery(customerId);
//   const [orderHistoryDetailsFn, { data: orderData, isLoading: orderLoading, error: orderError }] = useOrderHistoryDetailsMutation();
//   const { data: orderDetailsData, isLoading: orderDetailsLoading } = useGetOrderDetailsByOrderidQuery(selectedOrder, {
//   skip: !selectedOrder, 
// });
//  console.log("orderData",orderData)
//   useEffect(() => {
//     if (data?.customer_details) {
//       setCustomer(data.customer_details);
//       orderHistoryDetailsFn({ customer_id: customerId });
//     }
//   }, [data, orderHistoryDetailsFn]);

//   const handleViewClick = (id) => {
//     setSelectedOrder(id);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedOrder(null);
//   };

//   return (
//     <>
//     <section className="py-5" style={{ backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-lg-12">
//             <div className="card shadow-sm p-4">
//             <div className="row">
//               {/* Sidebar menu */}
//               {customer && (
//                 <SideviewProfile firstName={customer.first_name} mobile={customer.mobile} />
//               )}
              
//               {/* Profile info */}
//               <div className="col-md-8">
//                 <div className="card card-body account-right">
//                   <div className="widget">
//                     <div className="section-header">
//                       <h5 className="heading-design-h5">Order List</h5>
//                       {/* {orderLoading && <p>Loading order history...</p>}
//                       {orderData && <p>Order history loaded!</p>}
//                       {orderError && <p>Error loading order history</p>} */}
//                     </div>
//                     <div style={{ overflowX: 'visible' }}>
//                       <table className="table table-sm table-bordered table-hover text-center">
//                         <thead class="table-dark">
//                           <tr>
//                             <th>order #</th>
//                             <th>Date Purchased</th>
//                             <th>Total Items</th>
//                             <th>Total </th>
//                             <th>Status </th>
//                             <th>Action </th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {orderData?.ordersList?.map((order)=>
//                           <tr>
//                             <td>{order.order_id}</td>
//                             <td>{order.created_date}</td>
//                             <td>{order.total_items}</td>
//                             <td>{order.total_amount}</td>
//                             <td>{order.status}</td>
//                             <td><button className="btn btn-sm btn-primary" onClick={() => handleViewClick(order.order_id)}>
//                                  <i className="ph ph-eye me-1"></i> 
//                               </button></td>
//                           </tr>
//                           )}
                          
                          
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               {/* End Profile info */}
//             </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   {isModalOpen && (
//     <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
//   <div className="modal-dialog " style={{ maxWidth: '95%', width: '95%' }}>
//     <div className="modal-content">
//       {orderDetailsLoading ? (
//             <p>Loading...</p>
//           ) : orderDetailsData ? (
//             <>
            
//       {/* Modal Header */}
//       <div className="modal-header d-flex justify-content-between align-items-start">
        
//         <div className="row w-100">
//           {/* Billing Address */}
//           <div className="col-md-6">
//             <h4 className="modal-title">Billing Address:</h4>
//             <hr />
//             <div className="table-responsive">
//               <table style={{ width: '100%' }}>
//                 <tbody>
//                   <tr>
//                     <td>customer_id:</td>
//                     <td>{customerId}</td>
//                     <td>Name:</td>
//                     <td>{orderDetailsData.billing_address?.first_name} {orderDetailsData.billing_address?.last_name}</td>
//                   </tr>
//                   <tr>
//                     <td>email_id:</td>
//                     <td>{orderDetailsData.billing_address?.email_id}</td>
//                     <td>mobile:</td>
//                     <td>{orderDetailsData.billing_address?.mobile}</td>
//                   </tr>
//                   <tr>
//                     <td>created_date:</td>
//                     <td>{orderDetailsData.billing_address?.created_date}</td>
//                     <td>updated_date:</td>
//                     <td>{orderDetailsData.billing_address?.updated_date}</td>
//                   </tr>
//                   <tr>
//                     <td>address field1:</td>
//                     <td>{orderDetailsData.billing_address?.addr_field1}</td>
//                     <td>address field2:</td>
//                     <td>{orderDetailsData.billing_address?.addr_field2}</td>
//                   </tr>
//                   <tr>
//                     <td>address field3:</td>
//                     <td>{orderDetailsData.billing_address?.addr_field3}</td>
//                     <td>address field4:</td>
//                     <td>{orderDetailsData.billing_address?.addr_field4}</td>
//                   </tr>
//                   <tr>
//                     <td>address field5:</td>
//                     <td>{orderDetailsData.billing_address?.addr_field5}</td>
//                     <td>pincode:</td>
//                     <td>{orderDetailsData.billing_address?.pin_code}</td>
//                   </tr>
//                   <tr>
//                     <td><strong>Order ID:</strong></td>
//                     <td colSpan="3"><strong>{selectedOrder}</strong></td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Shipping Address */}
//           <div className="col-md-6">
//             <h4 className="modal-title">Shipping Address:</h4>
//             <hr />
//             <div className="table-responsive">
//               <table style={{ width: '100%' }}>
//                 <tbody>
//                   <tr>
//                     <td>customer_id:</td>
//                     <td>{customerId}</td>
//                     <td>Name:</td>
//                     <td>{orderDetailsData.shipping_address?.first_name} {orderDetailsData.shipping_address?.last_name}</td>
//                   </tr>
//                   <tr>
//                     <td>email_id:</td>
//                     <td>{orderDetailsData.shipping_address?.email_id}</td>
//                     <td>mobile:</td>
//                     <td>{orderDetailsData.shipping_address?.mobile}</td>
//                   </tr>
//                   <tr>
//                     <td>created_date:</td>
//                     <td>{orderDetailsData.shipping_address?.created_date}</td>
//                     <td>updated_date:</td>
//                     <td>{orderDetailsData.shipping_address?.updated_date}</td>
//                   </tr>
//                   <tr>
//                     <td>address field1:</td>
//                     <td>{orderDetailsData.shipping_address?.addr_field1}</td>
//                     <td>address field2:</td>
//                     <td>{orderDetailsData.shipping_address?.addr_field2}</td>
//                   </tr>
//                   <tr>
//                     <td>address field3:</td>
//                     <td>{orderDetailsData.shipping_address?.addr_field3}</td>
//                     <td>address field4:</td>
//                     <td>{orderDetailsData.shipping_address?.addr_field4}</td>
//                   </tr>
//                   <tr>
//                     <td>address field5:</td>
//                     <td>{orderDetailsData.shipping_address?.addr_field5}</td>
//                     <td>pincode:</td>
//                     <td>{orderDetailsData.shipping_address?.pin_code}</td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
          
//         </div>
//         <button type="button" className="btn-close" onClick={closeModal}></button>
//       </div>

//       {/* Modal Body */}
//       <div className="modal-body">
//         <table className="table table-striped">
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Product Name</th>
//               <th>Unit/Type</th>
//               <th>MRP</th>
//               <th>GST</th>
//               <th>Qty</th>
//               <th>Sale Price</th>
//               <th>Total Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             {orderDetailsData.orderList?.map((product, index) => (
//               <tr key={index}>
//                 <td>{index + 1}</td>
//                 <td>{product.product_name}</td>
//                 <td>{product.unit_value}{product.unit_type}</td>
//                 <td>{product.mrp}</td>
//                 <td>{product.gst_slab}%</td>
//                 <td>{product.quantity}</td>
//                 <td>{product.sale_price}</td>
//                 <td>{product.total_amount}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//        </>
//           ) : (
//             <p>No order details found.</p>
//           )}

//       {/* Modal Footer */}
//       <div className="modal-footer">
//         <button type="button" className="btn btn-danger" onClick={closeModal}>Close</button>
//       </div>
//     </div>
//   </div>
// </div>


//   )}
//   </>
//   );
// }

// export default OrderList;




// src/components/OrderList.jsx
import React, { useEffect, useState, useMemo } from 'react';
import SideviewProfile from './SideviewProfile';
import { useGetCustomerDetailsByIdQuery, useOrderHistoryDetailsMutation } from '../services/customerApi';
import { useGetOrderDetailsByOrderidQuery } from '../services/ordersApi';

function OrderList() {
  const [customer, setCustomer] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const customerId = (() => {
    try {
      return JSON.parse(localStorage.getItem('customer_id'));
    } catch {
      return localStorage.getItem('customer_id');
    }
  })();

  const { data, isLoading: customerLoading } = useGetCustomerDetailsByIdQuery(customerId);
  const [orderHistoryDetailsFn, { data: orderData, isLoading: orderLoading, error: orderError }] =
    useOrderHistoryDetailsMutation();

  const { data: orderDetailsData, isLoading: orderDetailsLoading } = useGetOrderDetailsByOrderidQuery(
    selectedOrder,
    { skip: !selectedOrder }
  );

  useEffect(() => {
    if (data?.customer_details) {
      setCustomer(data.customer_details);
      orderHistoryDetailsFn({ customer_id: customerId });
    }
  }, [data, orderHistoryDetailsFn, customerId]);

  const handleViewClick = (id) => {
    setSelectedOrder(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  // Helpers: format currency and date
  const formatCurrency = (v) => {
    const n = Number(v || 0);
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format(n);
  };

  const formatNumber = (v) => {
    const n = Number(v || 0);
    return n.toFixed(2);
  };

  const formatDate = (raw) => {
    if (!raw) return '';
    // if timestamp in seconds (e.g. unix seconds) convert; otherwise try Date directly
    const asNumber = Number(raw);
    let d;
    if (String(raw).length === 10 && !Number.isNaN(asNumber)) {
      d = new Date(asNumber * 1000);
    } else {
      d = new Date(raw);
    }
    if (isNaN(d)) return String(raw);
    return d.toLocaleString();
  };

  // Compute per-selected-order totals from orderDetailsData.orderList
  const { orderProductsTotal, orderProductsQty } = useMemo(() => {
    if (!orderDetailsData || !Array.isArray(orderDetailsData.orderList)) {
      return { orderProductsTotal: 0, orderProductsQty: 0 };
    }
    let total = 0;
    let qty = 0;
    orderDetailsData.orderList.forEach((p) => {
      // prefer total_amount else compute
      const rawTotal = p?.total_amount ?? (Number(p?.quantity ?? 0) * Number(p?.sale_price ?? 0));
      const part = Number(String(rawTotal).replace(/,/g, '')) || 0;
      total += part;
      qty += Number(p?.quantity ?? 0) || 0;
    });
    return { orderProductsTotal: total, orderProductsQty: qty };
  }, [orderDetailsData]);

  // Compute totals to display in the order rows (safe fallback if backend missing)
  const ordersWithTotals = useMemo(() => {
    if (!Array.isArray(orderData?.ordersList)) return [];
    return orderData.ordersList.map((order) => {
      // If backend provided total_amount and total_items, use them; else compute from orderList if present
      let totalAmount = Number(order.total_amount ?? 0);
      let totalItems = Number(order.total_items ?? 0);

      // if order contains an embedded orderList we can compute robustly
      if (Array.isArray(order.orderList) && order.orderList.length) {
        const computed = order.orderList.reduce((acc, p) => {
          const pTotal = Number(String(p?.total_amount ?? (Number(p?.quantity || 0) * Number(p?.sale_price || 0))).replace(/,/g, '')) || 0;
          acc.total += pTotal;
          acc.qty += Number(p?.quantity ?? 0) || 0;
          return acc;
        }, { total: 0, qty: 0 });

        // prefer computed if backend value is zero/undefined
        if (!totalAmount || totalAmount === 0) totalAmount = computed.total;
        if (!totalItems || totalItems === 0) totalItems = computed.qty;
      }

      return { ...order, _computed_total: totalAmount, _computed_qty: totalItems };
    });
  }, [orderData]);

  return (
    <>
      <section className="py-5" style={{ backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 p--24">
              <div className="card shadow-sm p-4">
                <div className="row">
                  {/* Sidebar */}
                  {customer && <SideviewProfile firstName={customer.first_name} mobile={customer.mobile} />}

                  {/* Orders table */}
                  <div className="col-md-8" style={{ paddingTop: '24px' }}>
                    <div className="card card-body account-right " >
                      <div className="widget">
                        <div className="section-header d-flex align-items-center justify-content-between" >
                          <h5 className="heading-design-h5 mb-5">Order List</h5>
                          {orderLoading && <small className="text-muted">Loading orders...</small>}
                        </div>

                        <div style={{ overflowX: 'auto' }} className="mt-3">
                          <table className="table table-sm table-bordered table-hover text-center">
                            <thead className="table-dark">
                              <tr>
                                <th style={{ padding: '6px' , textAlign:'center', backgroundColor:'#e96125'}}>Order #</th>
                                <th style={{ padding: '6px' , textAlign:'center', backgroundColor:'#e96125'}}>Date Purchased</th>
                                <th style={{ padding: '6px' , textAlign:'center', backgroundColor:'#e96125'}}>Total Items</th>
                                <th style={{ padding: '6px' , textAlign:'center', backgroundColor:'#e96125'}}>Total</th>
                                <th style={{ padding: '6px' , textAlign:'center', backgroundColor:'#e96125'}}>Status</th>
                                <th style={{ padding: '6px' , textAlign:'center', backgroundColor:'#e96125'}}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {ordersWithTotals.length > 0 ? (
                                ordersWithTotals.map((order) => (
                                  <tr key={order.order_id}>
                                    <td style={{ padding: '6px 15px' , textAlign:'center'}}>{order.order_id}</td>
                                    <td style={{ padding: '6px 15px' , textAlign:'center'}}>{formatDate(order.created_date)}</td>
                                    <td style={{ padding: '6px 15px' , textAlign:'center'}}>{order._computed_qty}</td>
                                    <td style={{ padding: '6px 15px' , textAlign:'center'}}>{formatCurrency(order._computed_total)}</td>
                                    <td style={{ padding: '6px 15px' , textAlign:'center'}}>{order.status}</td>
                                    <td style={{ padding: '6px 15px' , textAlign:'center'}}>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        type="button"
                                        onClick={() => handleViewClick(order.order_id)}
                                      >
                                        <i className="ph ph-eye me-1" /> View
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6">{orderLoading ? 'Loading orders...' : 'No orders found.'}</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* end col */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          role="dialog"
          aria-modal="true"
        >
          <div className="modal-dialog modal-xl modal-dialog-centered" style={{ maxWidth: '95%' }}>
            <div className="modal-content">
              {orderDetailsLoading ? (
                <div className="p-4">Loading...</div>
              ) : orderDetailsData ? (
                <>
                  <div className="modal-header">
                    <h5 className="modal-title">Order Details</h5>
                    <button type="button" className="btn-close" onClick={closeModal} aria-label="Close" />
                  </div>

                  <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <h6>Billing Address</h6>
                        <table className="table table-borderless table-sm mb-0">
                          <tbody>
                            <tr>
                              <td>Order ID:</td>
                              <td><strong>{selectedOrder}</strong></td>
                              <td style={{ textAlign:'left'}}>Total Items:</td>
                              <td>{orderProductsQty}</td>
                            </tr>
                            <tr>
                              <td>Grand Total:</td>
                              <td><strong>{formatCurrency(orderProductsTotal)}</strong></td>
                              <td style={{ textAlign:'left'}}>Customer:</td>
                              <td>{orderDetailsData.billing_address?.first_name} {orderDetailsData.billing_address?.last_name}</td>
                            </tr>
                            <tr>
                              <td>Mobile:</td>
                              <td>{orderDetailsData.billing_address?.mobile}</td>
                              <td style={{ textAlign:'left'}}>Email:</td>
                              <td>{orderDetailsData.billing_address?.email_id}</td>
                            </tr>
                            <tr>
                              <td>Address:</td>
                              <td colSpan="3">
                                {[
                                  orderDetailsData.billing_address?.addr_field1,
                                  orderDetailsData.billing_address?.addr_field2,
                                  orderDetailsData.billing_address?.addr_field3,
                                  orderDetailsData.billing_address?.addr_field4,
                                  orderDetailsData.billing_address?.addr_field5
                                ].filter(Boolean).join(', ')}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div className="col-md-6">
                        <h6>Shipping Address</h6>
                        <table className="table table-borderless table-sm mb-0">
                          <tbody>
                            <tr>
                              <td>Customer:</td>
                              <td>{orderDetailsData.shipping_address?.first_name} {orderDetailsData.shipping_address?.last_name}</td>
                              <td style={{ textAlign:'left'}}>Mobile:</td>
                              <td>{orderDetailsData.shipping_address?.mobile}</td>
                            </tr>
                            <tr>
                              <td>Email:</td>
                              <td>{orderDetailsData.shipping_address?.email_id}</td>
                              <td style={{ textAlign:'left'}}>Pincode:</td>
                              <td>{orderDetailsData.shipping_address?.pin_code}</td>
                            </tr>
                            <tr>
                              <td>Address:</td>
                              <td colSpan="3">
                                {[
                                  orderDetailsData.shipping_address?.addr_field1,
                                  orderDetailsData.shipping_address?.addr_field2,
                                  orderDetailsData.shipping_address?.addr_field3,
                                  orderDetailsData.shipping_address?.addr_field4,
                                  orderDetailsData.shipping_address?.addr_field5
                                ].filter(Boolean).join(', ')}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="table-responsive" style={{ marginTop:'30px'}}>
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Product Name</th>
                            <th>Unit/Type</th>
                            <th>MRP</th>
                            <th>GST</th>
                            <th>Qty</th>
                            <th>Sale Price</th>
                            <th>Total Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(orderDetailsData.orderList) && orderDetailsData.orderList.length > 0 ? (
                            orderDetailsData.orderList.map((product, index) => (
                              <tr key={product.product_id ?? index}>
                                <td style={{ textAlign:'center', padding:'16px 10px'}}>{index + 1}</td>
                                <td style={{ textAlign:'center', padding:'16px 10px'}}>{product.product_name}</td>
                                <td style={{ textAlign:'center', padding:'16px 10px'}}>{product.unit_value}{product.unit_type}</td>
                                <td style={{ textAlign:'center', padding:'16px 10px'}}>{formatNumber(product.mrp)}</td>
                                <td style={{ textAlign:'center', padding:'16px 10px'}}>{Number(product.gst_slab || 0).toFixed(2)}%</td>
                                <td style={{ textAlign:'center', padding:'16px 10px'}}>{product.quantity}</td>
                                <td style={{ textAlign:'center', padding:'16px 10px'}}>{formatNumber(product.sale_price)}</td>
                                <td style={{ textAlign:'center', padding:'16px 10px'}}>{formatNumber(product.total_amount)}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8">No products found for this order.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <div className="me-auto">
                      <strong>Total Items:</strong> {orderProductsQty} &nbsp; | &nbsp;
                      <strong>Grand Total:</strong> {formatCurrency(orderProductsTotal)}
                    </div>
                    <button type="button" className="btn btn-danger" onClick={closeModal}>Close</button>
                  </div>
                </>
              ) : (
                <div className="p-4">No order details found.</div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default OrderList;
